import React, { Component } from 'react';
import { Navbar, NavbarBrand,} from 'reactstrap';
import './LandingHeader.css';

class LandingNav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    render() {
        return (
            <div className="LandingNav">
                <Navbar color="faded" light expand="md">
                    <NavbarBrand className="noselect">Veles</NavbarBrand>
                </Navbar>
            </div>
        );

    }
};

export default LandingNav;



// WEBPACK FOOTER //
// ./src/components/App/components/Header/components/LandingHeader/LandingHeader.js